
export const getUserFeaturesConfig = () => ({
    url: '/api/users/me/features/',
    method: 'GET',
});
